import CCColors from '@/Utils/CCColors';
import React, {useEffect, useState} from 'react';
import {Pressable, View, StyleSheet} from 'react-native';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
} from 'react-native-reanimated';

const ToggleSwitch = ({
  isOn = false, // Controlled value
  onToggle = () => {},
}) => {
  const offset = useSharedValue(isOn ? 1 : 0);

  const toggleSwitch = () => {
    const newValue = !isOn;
    onToggle(newValue);
    offset.value = withTiming(newValue ? 1 : 0, {duration: 250});
  };
  // Keep offset in sync with external `isOn`
  useEffect(() => {
    offset.value = withTiming(isOn ? 1 : 0, {duration: 250});
  }, [isOn]);
  // Background color animation
  const bgStyle = useAnimatedStyle(() => {
    return {
      backgroundColor:
        offset.value === 1 ? CCColors.BlueAqua : CCColors.TextColor.Grey,
    };
  });

  // Knob animation (moves left ↔ right)
  const knobStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          translateX: withTiming(offset.value === 1 ? 16 : 0, {duration: 250}),
        },
      ],
      backgroundColor: CCColors.White,
    };
  });

  return (
    <Pressable onPress={toggleSwitch}>
      <Animated.View style={[styles.container, bgStyle]}>
        <Animated.View style={[styles.knob, knobStyle]} />
      </Animated.View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 32,
    height: 16,
    borderRadius: 16,
    justifyContent: 'center',
    padding: 2,
  },
  knob: {
    width: 12,
    height: 12,
    borderRadius: 12,
  },
});

export default ToggleSwitch;
